import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import { customerDetailsReducer, loyaltyDetailsReducer, loyaltyTierConfigReducer, userOtpReducer, allProductsReducer} from './modules/CustomerDetails'

export default (store) => ({
  path: 'customer-details/:mobile',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const {
        loadBrandNamesReducer,
        loadStoreTagOptionsReducer,
        loadStoreOptionsReducer
      } = require('../SalesAnalytics/modules/salesAnalytics')
      const {loadOpportunitiesReducer} = require('../Opportunities/modules/Opportunities')
      const CustomerDetails = require('./containers/CustomerDetails').default
      injectReducer(store, {key: 'customerDetails', reducer: customerDetailsReducer})
      injectReducer(store, {key: 'loyaltyDetails', reducer: loyaltyDetailsReducer})
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})
      injectReducer(store, {key: 'loyaltyTiersConfig', reducer: loyaltyTierConfigReducer})
      injectReducer(store, {key: 'userOtp', reducer: userOtpReducer})
      injectReducer(store, {key: 'opportunities', reducer: loadOpportunitiesReducer})
      injectReducer(store, {key: 'allProducts', reducer: allProductsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})

      cb(null, CustomerDetails)
      /* Webpack named bundle   */
    }, 'categoryDetails')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CustomerDetails/index.js